/* eslint-disable max-len */
import { defineMessages } from 'react-intl';

export default defineMessages({
    ExpireQuoteHeader: {
        id: 'qnb.expiredQuoteModal.ExpireQuoteHeader',
        defaultMessage: 'Your previous quote has expired'
    },
    DateLabel: {
        id: 'qnb.expiredQuoteModal.DateLabel',
        defaultMessage: 'Please enter your cover start date to get the latest price'
    },
    DateHelp: {
        id: 'qnb.expiredQuoteModal.DateHelp',
        defaultMessage: 'If you are currently insured you should use the renewal / cover start date shown on your documents to ensure continuous cover.'
    },
    DetailsChanged: {
        id: 'qnb.expiredQuoteModal.DetailsChanged',
        defaultMessage: 'If your details have changed since your last quote, please '
    },
    ReviewDetails: {
        id: 'qnb.expiredQuoteModal.ReviewDetails',
        defaultMessage: 'review your details.'
    },
    Continue: {
        id: 'qnb.expiredQuoteModal.Continue',
        defaultMessage: 'Continue'
    },
});
